import { useState, useCallback, useEffect } from 'react';

function useDelayedModalState(id, animationDuration, closeClassName = 'closing', initiallyOpened = false) {
    const [closing, setIsClosing] = useState(false);
    const [open, setOpened] = useState(initiallyOpened);
    const setOpen = useCallback((shouldBeOpened) => {
        if (shouldBeOpened)
            setOpened(true);
        else
            setIsClosing(true);
    }, []);
    useEffect(() => {
        if (open)
            setIsClosing(false);
    }, [open]);
    useEffect(() => {
        const dialog = document.getElementById(id);
        if (closing)
            dialog.classList.add(closeClassName);
        return () => {
            if (dialog)
                dialog.classList.remove(closeClassName);
        };
    }, [id, closing, closeClassName]);
    useEffect(() => {
        let timeout;
        if (closing) {
            timeout = window.setTimeout(() => {
                setOpened(false);
            }, animationDuration);
        }
        return () => window.clearTimeout(timeout);
    }, [closing, animationDuration]);
    return [open, setOpen];
}

export { useDelayedModalState };
